export default class HorizontalBarchartController {
  constructor() {
    // TODO remove hack
    this.rates = [5,4,3,2,1];
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/dashboard/components/horizontal-barchart/horizontal-barchart.controller.js